import { render, staticRenderFns } from "./pages-head.vue?vue&type=template&id=177e65ad"
import script from "./pages-head.vue?vue&type=script&lang=js"
export * from "./pages-head.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports